import React from 'react';
import { CheckIcon } from 'lucide-react';
import { FOR_YOUR_CHILD } from '../lib/content';
import { Reveal } from './Reveal';
const CARD_COLORS = [{
  border: 'border-l-[#FF6B35]',
  bg: 'bg-[#FFF0EB]'
}, {
  border: 'border-l-[#4A65FF]',
  bg: 'bg-[#EDF0FF]'
}, {
  border: 'border-l-[#34C759]',
  bg: 'bg-[#EBFAEF]'
}, {
  border: 'border-l-[#FF9F43]',
  bg: 'bg-[#FFF5EB]'
}, {
  border: 'border-l-[#A55EEA]',
  bg: 'bg-[#F6F0FD]'
}, {
  border: 'border-l-[#FFC048]',
  bg: 'bg-[#FFF8EB]'
}];
export function ForYourChild() {
  return <section className="w-full bg-gradient-to-b from-[#F2F8FF] via-white to-white py-16 sm:py-24" data-id="element-165" data-mp="3d3fyog79bjle">
      <div className="mx-auto w-full max-w-2xl px-5 sm:px-8" data-id="element-166" data-mp="3s102hjsf38pz">
        <Reveal data-id="element-167" data-mp="3mzssrf6przgo">
          <div className="relative text-center" data-id="element-168" data-mp="3mzaopwdt8gy7">
            {/* Decorative Stars */}
            <div className="absolute left-4 top-4 text-xl opacity-60" aria-hidden="true" data-id="element-169" data-mp="178eqvlrlr4af">✨</div>
            <div className="absolute right-4 bottom-0 text-2xl opacity-80" aria-hidden="true" data-id="element-170" data-mp="12amqe3cw69um">⭐</div>

            <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 font-display text-[10px] font-black uppercase tracking-widest text-[#FF6B35] shadow-sm sm:text-xs" data-id="element-171" data-mp="17krra1fck4oc">
              {FOR_YOUR_CHILD.title}
            </span>
            
            <h2 className="mt-6 font-display text-3xl font-black leading-[1.1] sm:text-5xl" data-id="element-172" data-mp="1hgbnkoxtp5dm">
              <span className="block text-[#1C3587] text-[36px] font-[Barlow,_sans-serif]" data-id="element-173" data-mp="1lhf1v7082tcq">{FOR_YOUR_CHILD.subtitle}</span>
              <span className="block animate-shine bg-[linear-gradient(110deg,#F27B35,45%,#FFD147,55%,#F27B35)] bg-[length:200%_auto] bg-clip-text text-transparent text-[32px] font-[Barlow,_sans-serif]" data-id="element-174" data-mp="tsbu3h94n0vc">
                {FOR_YOUR_CHILD.description}
              </span>
            </h2>
            
            <p className="mx-auto mt-4 max-w-md font-display text-[15px] font-bold leading-snug text-[#4A5568] sm:text-lg" data-id="element-175" data-mp="6392phooxtnn">
              {FOR_YOUR_CHILD.tagline}
            </p>
          </div>

          <div className="mt-10 flex flex-col gap-3 sm:gap-4" data-id="element-176" data-mp="1df8iac3a2xs8">
            {FOR_YOUR_CHILD.items.map((item, i) => {
            const colorStyle = CARD_COLORS[i % CARD_COLORS.length];
            return <Reveal key={i} delay={i * 0.05} float={true} data-id="element-177" data-mp="1n5tdrqnnnm6x" data-mpi={i}>
                  <div className={`group relative overflow-hidden flex items-center gap-4 rounded-2xl border-l-[6px] bg-white p-4 shadow-[0_4px_20px_rgba(0,0,0,0.04)] sm:p-5 ${colorStyle.border}`} data-id="element-178" data-mp="1n74ibsoxcxz3">
                  <span className={`flex h-12 w-12 flex-none items-center justify-center rounded-2xl text-2xl ${colorStyle.bg}`} aria-hidden="true" data-id="element-179" data-mp="uiqlhg9ko7p4">
                    {item.emoji}
                  </span>
                  <div className="flex-1" data-id="element-180" data-mp="13ezkwuxjv6b9">
                    <h3 className="font-display text-[15px] font-black leading-tight text-[#1C3587] sm:text-lg" data-id="element-181" data-mp="zenypdpjgxxo">
                      {item.title}
                    </h3>
                    <p className="mt-0.5 text-[11px] font-bold text-[#4A5568] sm:text-sm" data-id="element-182" data-mp="2av5v5dt4z0kb">
                      {item.description}
                    </p>
                  </div>
                  <div className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-[#34C759] shadow-sm sm:h-7 sm:w-7" data-id="element-183" data-mp="2igrlphzkt5ld">
                    <CheckIcon className="h-3.5 w-3.5 text-white sm:h-4 sm:w-4" strokeWidth={4} data-id="element-184" data-mp="28h0rziiuaumc" />
                  </div>
                </div>
                </Reveal>;
          })}
          </div>

          <div className="mt-6 relative overflow-hidden rounded-2xl border border-[#FAD3B4] bg-gradient-to-r from-[#FFF5ED] to-[#FFF0E0] p-5 shadow-sm sm:p-6" data-id="element-185" data-mp="315xzqrpfd90u">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_4s_infinite] bg-gradient-to-r from-transparent via-white/50 to-transparent" style={{
            animationDelay: '2s'
          }} data-id="element-186" data-mp="2rfd1549r44hx" />
            <div className="flex items-center gap-4 relative z-10" data-id="element-187" data-mp="3k3qzjl4r52u0">
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-[#FF8C22] text-2xl shadow-sm" aria-hidden="true" data-id="element-188" data-mp="3k2fw5mf7xx3f">
                ✨
              </span>
              <div data-id="element-189" data-mp="217qp2ni0kw87">
                <h4 className="font-display text-[9px] font-black uppercase tracking-widest text-[#D97706] sm:text-[10px]" data-id="element-190" data-mp="2142t7hp3jxqb">
                  EL CAMBIO QUE BUSCÁS
                </h4>
                <p className="mt-0.5 font-display text-lg font-black leading-tight text-[#9C4221] sm:text-xl" data-id="element-191" data-mp="1r8hvvwuz3lmw">
                  Menos "me aburro", más "mirá lo que hice".
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}